import { store } from "../../..";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

export const TypesMxAlerta = {
    OPENALERTA: "mxalerta/OPEN",
    CLOSEALERTA: "mxalerta/CLOSE",
    OPENCONFIRM: "mxalerta/OPENCONFIRM",
    OPEN_CONFIRM_WITH_CANCEL: "mxalerta/OPEN_CONFIRM_WITH_CANCEL",
    OPENERRO: "mxalerta/OPENERRO",
    OPENALERTAUPDATE: "mxalerta/OPENUPDATE",
    OPENONLYCONFIRM: "mxalerta/OPENONLYCONFIRM",
    OPENALERTACOMCONFIRMACAO: "mxalerta/OPENALERTACOMCONFIRMACAO",
    OPENCONFIRM_LISTDETAILS: "mxalerta/OPENCONFIRM_LISTDETAILS",
};

const INITIAL = {
    Open: false,
    Titulo: "",
    Texto: "",
    Mensagem: "",
    Tipo: "success",
    ShowButtonAtualizar: false,
    OkClick: () => { },
    SimClick: () => { },
    NaoClick: () => { },
    AlertTipo: "",
    Parametro: "",
    CancelButton: false,
    CancelText: "Cancelar",
    ConfirmText: "Confirmar",
    OkText: "Ok"
};

export default function MxAlertaReducer(state = INITIAL, action) {
    //console.log(action);

    switch (action.type) {
        case TypesMxAlerta.OPENALERTA:
            return {
                ...state,
                Open: true,
                Mensagem: action.payload.Mensagem,
                Tipo: action.payload.Tipo,
                ShowButtonAtualizar: action.payload.ShowButtonAtualizar,
                AlertTipo: "OPENALERTA",
                CancelButton: action.payload.cancelar || false
            };
        case TypesMxAlerta.CLOSEALERTA:
            return { ...state, Open: false };
        case TypesMxAlerta.OPENCONFIRM:
            return {
                ...state,
                Open: true,
                Texto: action.payload.Texto,
                Titulo: action.payload.Titulo,
                SimClick: action.payload.SimClick,
                NaoClick: action.payload.NaoClick,
                AlertTipo: "OPENCONFIRM",
                Parametro: action.payload.Parametro,
                CancelButton: action.payload.cancelar || false
            };

        case TypesMxAlerta.OPENERRO:
            return {
                ...state,
                Open: true,
                Texto: action.payload.Texto,
                Titulo: action.payload.Titulo,
                OkClick: action.payload.OkClick,
                AlertTipo: "OPENERRO",
                CancelButton: action.payload.cancelar || false
            };
        case TypesMxAlerta.OPENALERTAUPDATE:
            return {
                ...state,
                Open: true,
                Mensagem: action.payload.Mensagem,
                Tipo: action.payload.Tipo,
                ShowButtonAtualizar: action.payload.ShowButtonAtualizar,
                AlertTipo: "OPENALERTAUPDATE",
                CancelButton: action.payload.cancelar || false
            };
        case TypesMxAlerta.OPENONLYCONFIRM:
            return {
                ...state,
                Open: true,
                Texto: action.payload.Texto,
                Titulo: action.payload.Titulo,
                SimClick: action.payload.onConfirmar,
                NaoClick: action.payload.onCancelar,
                AlertTipo: "OPENONLYCONFIRM",
                CancelText: action.payload.cancelarTexto || "Cancelar",
                ConfirmText: action.payload.confirmarTexto || "Confirmar"
            };
        case TypesMxAlerta.OPENALERTACOMCONFIRMACAO:
            return {
                ...state,
                Open: true,
                Texto: action.payload.Texto,
                Titulo: action.payload.Titulo,
                SimClick: action.payload.onConfirmar,
                AlertTipo: "OPENOKCONFIRM",
                ConfirmText: action.payload.confirmarTexto || "Ok"
            };
        case TypesMxAlerta.OPENCONFIRM_LISTDETAILS:
            return {
                ...state,
                Open: true,
                Texto: action.payload.Texto,
                Titulo: action.payload.Titulo,
                SimClick: action.payload.SimClick,
                NaoClick: action.payload.NaoClick,
                AlertTipo: "OPENCONFIRM",
                Parametro: action.payload.Parametro,
                CancelButton: action.payload.cancelar || false
            };

        default:
            return state;
    }
}

export const MxAlertaActions = {
    Executar,
    ExecutarComButtonAtualizar,
    ExecutarConfirm,
    ExecutarClose,
    Executarerro,
    ExecutarComButtonAtualizarApp,
    ExecutarConfirmOnly,
    ExecutarAlertaComConfirmacao,
    ExecutarConfirmListDetails
};

function ExecutarClose() {
    return {
        type: TypesMxAlerta.CLOSEALERTA
    };
}

/**
 *
 * @param {string} titulo
 * @param {string} texto
 * @param {() => void} simClick - função a ser executada ao clicar em sim, automaticamente fecha o alerta
 * @param {() => void} naoClick - função a ser executada ao clicar em não, automaticamente fecha o alerta
 * @param {boolean} [cancelar=true] - se true, mostra o botão cancelar
 * @param {any} [parametro]
 * @param {boolean} defaultClose - automaticamente fecha o modal depois das funções simClick e naoClick
 * @returns
 */
function ExecutarConfirm(
    titulo,
    texto,
    simClick,
    naoClick,
    cancelar = false,
    parametro,
    defaultClose = true
) {
    //console.log('Thiago');
    //dispatch({ type: 'mxalerta/OPEN' });
    return {
        type: TypesMxAlerta.OPENCONFIRM,
        payload: {
            Titulo: titulo,
            Texto: texto,
            SimClick: () => {
                simClick();
                defaultClose ? store.dispatch(ExecutarClose()) : console.log();
            },
            NaoClick: () => {
                naoClick();
                defaultClose ? store.dispatch(ExecutarClose()) : console.log();
            },
            Parametro: parametro,
            cancelar
        }
    };
}

/**
 *
 * @param {string} titulo
 * @param {string} texto
 * @param {() => void} simClick - função a ser executada ao clicar em sim, automaticamente fecha o alerta
 * @param {() => void} naoClick - função a ser executada ao clicar em não, automaticamente fecha o alerta
 * @param {boolean} [cancelar=true] - se true, mostra o botão cancelar
 * @param {any} [parametro]
 * @param {boolean} defaultClose - automaticamente fecha o modal depois das funções simClick e naoClick
 * @returns
 */
function ExecutarConfirmListDetails(
    titulo,
    texto,
    simClick,
    naoClick,
    cancelar = false,
    parametro,
    defaultClose = true
) {
    return {
        type: TypesMxAlerta.OPENCONFIRM_LISTDETAILS,
        payload: {
            Titulo: titulo,
            Texto:
                <>
                    {
                        <List>
                            {texto.map((item, index) => (
                                <ListItem key={index} divider disablePadding disableGutters>
                                    <ListItemText
                                        primary={item}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    }
                </>
            ,
            SimClick: () => {
                simClick();
                defaultClose ? store.dispatch(ExecutarClose()) : console.log();
            },
            NaoClick: () => {
                naoClick();
                defaultClose ? store.dispatch(ExecutarClose()) : console.log();
            },
            Parametro: parametro,
            cancelar
        }
    };
}

function Executarerro(titulo, texto, okClick) {
    return {
        type: TypesMxAlerta.OPENERRO,
        payload: {
            Titulo: titulo,
            Texto: texto,
            OkClick: okClick
        }
    };
}

/**
 * Executa um alerta com botão de Confirmação e Cancelar, sem o botão "Não"
 * @param {Object} params
 * @param {string} params.titulo
 * @param {string} params.texto
 * @param {() => void} [params.onConfirmar] - função a ser executada ao clicar em sim, automaticamente fecha o alerta
 * @param {() => void} [params.onCancelar] - função a ser executada ao clicar em cancelar, automaticamente fecha o alerta
 * @param {string} [params.confirmarTexto="Confirmar"] - texto do botão confirmar
 * @param {string} [params.cancelarTexto="Cancelar"] - texto do botão cancelar
 * @returns
 */
function ExecutarConfirmOnly({
    titulo,
    texto,
    onConfirmar = () => { },
    onCancelar = () => { },
    confirmarTexto = "Confirmar",
    cancelarTexto = "Cancelar"
}) {
    return {
        type: TypesMxAlerta.OPENONLYCONFIRM,
        payload: {
            Titulo: titulo,
            Texto: texto,
            onConfirmar: () => {
                store.dispatch(ExecutarClose());
                onConfirmar();
            },
            onCancelar: () => {
                store.dispatch(ExecutarClose());
                onCancelar();
            },
            confirmarTexto: confirmarTexto,
            cancelarTexto: cancelarTexto
        }
    };
}

/**
 *
 * @param {Object} params
 * @param {string} params.titulo
 * @param {string} params.texto
 * @param {() => void} [params.onConfirmar] - função a ser executada ao clicar em "Ok", automaticamente fecha o alerta
 * @param {string} [params.confirmarTexto="OK"] - texto do botão "Ok"
 * @returns
 */
function ExecutarAlertaComConfirmacao(
    titulo,
    texto,
    onConfirmar = () => { },
    confirmarTexto = "OK"
) {
    return {
        type: TypesMxAlerta.OPENALERTACOMCONFIRMACAO,
        payload: {
            Titulo: titulo,
            Texto: texto,
            onConfirmar: () => {
                store.dispatch(ExecutarClose());
                onConfirmar();
            },
            ConfirmarTexto: confirmarTexto
        }
    };
}


function Executar(mensagem, tipo) {
    //console.log("Thiago", mensagem);
    //dispatch({ type: 'mxalerta/OPEN' });
    return {
        type: TypesMxAlerta.OPENALERTA,
        payload: {
            Mensagem: mensagem,
            Tipo: tipo
        }
    };
}

function ExecutarComButtonAtualizar(mensagem, tipo) {
    //console.log('Thiago');
    //dispatch({ type: 'mxalerta/OPEN' });
    return {
        type: TypesMxAlerta.OPENALERTA,
        payload: {
            Mensagem: mensagem,
            Tipo: tipo,
            ShowButtonAtualizar: true
        }
    };
}

function ExecutarComButtonAtualizarApp(mensagem, tipo) {
    return {
        type: TypesMxAlerta.OPENALERTAUPDATE,
        payload: {
            Mensagem: mensagem,
            Tipo: tipo,
            ShowButtonAtualizar: true
        }
    };
}
